import { makeDynamicStyle } from './themeClasses';
import { store } from '../index';
import { handleFullLayoutLoader, handleThemeArr } from '../containers/MainLayout/mainLayoutSlice';

const STYLE_TAG_NAME = 'dynamic-root-style';
const STYLE_BUTTON_NAME = 'dynamic-button-style';
const STYLE_BUTTON_OUTLINE_NAME = 'dynamic-outline-button-style';
const STYLE_TEXT_BG_NAME = 'dynamic-text-bg-style';
const STYLE_BADGE_NAME = 'dynamic-badge-style';
const STYLE_BORDER_COLOR_NAME = 'dynamic-bordre-color-style';
const STYLE_TOAST_COLOR_NAME = 'dynamic-toast-color-style';

export const removeRootStyleTag = () => {
  const existingStyleTag = document.getElementById(STYLE_TAG_NAME);
  if (existingStyleTag) {
    existingStyleTag.parentNode.removeChild(existingStyleTag);
  }

  const existingStyleButton = document.getElementById(STYLE_BUTTON_NAME);
  if (existingStyleButton) {
    existingStyleButton.parentNode.removeChild(existingStyleButton);
  }

  const existingStyleButtonOutline = document.getElementById(STYLE_BUTTON_OUTLINE_NAME);
  if (existingStyleButtonOutline) {
    existingStyleButtonOutline.parentNode.removeChild(existingStyleButtonOutline);
  }

  const existingStyleTextBg = document.getElementById(STYLE_TEXT_BG_NAME);
  if (existingStyleTextBg) {
    existingStyleTextBg.parentNode.removeChild(existingStyleTextBg);
  }

  const existingStyleBadge = document.getElementById(STYLE_BADGE_NAME);
  if (existingStyleBadge) {
    existingStyleBadge.parentNode.removeChild(existingStyleBadge);
  }

  const existingStyleBorderColor = document.getElementById(STYLE_BORDER_COLOR_NAME);
  if (existingStyleBorderColor) {
    existingStyleBorderColor.parentNode.removeChild(existingStyleBorderColor);
  }

  const existingStyleToastColor = document.getElementById(STYLE_TOAST_COLOR_NAME);
  if (existingStyleToastColor) {
    existingStyleToastColor.parentNode.removeChild(existingStyleToastColor);
  }
};

export const addRootStyleTag = (data = {}) => {
  const {
    appendRootStr,
    buttonStyleString,
    buttonOutlineStyleString,
    textBgStyleString,
    badgeStyleString,
    borderColorStyleString,
    toastStyleString
  } = data ?? {};
  const existingStyleTag = document.getElementById(STYLE_TAG_NAME);
  if (!existingStyleTag) {
    if (appendRootStr) {
      // adding root variable
      const rootStyleTag = document.createElement('style');
      rootStyleTag.id = STYLE_TAG_NAME;
      rootStyleTag.insertAdjacentHTML('beforeend', `:root {${appendRootStr}}`);
      document.head.appendChild(rootStyleTag);
    }
  }

  const existingbuttonStyleTag = document.getElementById(STYLE_BUTTON_NAME);
  if (!existingbuttonStyleTag) {
    if (buttonStyleString) {
      // adding button class
      const btnStyle = document.createElement('style');
      btnStyle.id = STYLE_BUTTON_NAME;
      btnStyle.appendChild(document.createTextNode(buttonStyleString));
      document.head.appendChild(btnStyle);
    }
  }

  const existingbuttonOutlineStyleTag = document.getElementById(STYLE_BUTTON_OUTLINE_NAME);
  if (!existingbuttonOutlineStyleTag) {
    if (buttonOutlineStyleString) {
      // adding button outline class
      const btnOutlineStyle = document.createElement('style');
      btnOutlineStyle.id = STYLE_BUTTON_OUTLINE_NAME;
      btnOutlineStyle.appendChild(document.createTextNode(buttonOutlineStyleString));
      document.head.appendChild(btnOutlineStyle);
    }
  }

  const existingtextBgStyleTag = document.getElementById(STYLE_TEXT_BG_NAME);
  if (!existingtextBgStyleTag) {
    if (textBgStyleString) {
      // adding text bg class
      const textBgStyle = document.createElement('style');
      textBgStyle.id = STYLE_TEXT_BG_NAME;
      textBgStyle.appendChild(document.createTextNode(textBgStyleString));
      document.head.appendChild(textBgStyle);
    }
  }

  const existingbadgeStyleTag = document.getElementById(STYLE_BADGE_NAME);
  if (!existingbadgeStyleTag) {
    if (badgeStyleString) {
      // adding button outline class
      const badgeStyle = document.createElement('style');
      badgeStyle.id = STYLE_BADGE_NAME;
      badgeStyle.appendChild(document.createTextNode(badgeStyleString));
      document.head.appendChild(badgeStyle);
    }
  }

  const existingborderColorStyleTag = document.getElementById(STYLE_BORDER_COLOR_NAME);
  if (!existingborderColorStyleTag) {
    if (borderColorStyleString) {
      // adding button outline class
      const borderColorStyle = document.createElement('style');
      borderColorStyle.id = STYLE_BORDER_COLOR_NAME;
      borderColorStyle.appendChild(document.createTextNode(borderColorStyleString));
      document.head.appendChild(borderColorStyle);
    }
  }

  const existingtoastStyleTag = document.getElementById(STYLE_TOAST_COLOR_NAME);
  if (!existingtoastStyleTag) {
    if (toastStyleString) {
      // adding toast color class
      const toastColorStyle = document.createElement('style');
      toastColorStyle.id = STYLE_TOAST_COLOR_NAME;
      toastColorStyle.appendChild(document.createTextNode(toastStyleString));
      document.head.appendChild(toastColorStyle);
    }
  }
};

export const performThemeFn = async ({ user_id, token }) => {
  const states = store?.getState();
  let themeArr = states?.mainlayout?.themeArr;

  if (!token || (user_id && !token) || themeArr?.completeThemeSetArr?.length === 0) {
    store.dispatch(handleFullLayoutLoader(true));
    themeArr = await makeDynamicStyle({ user_id });
    await removeRootStyleTag();
    await addRootStyleTag(themeArr);
    store.dispatch(handleThemeArr(themeArr));
    setTimeout(() => {
      store.dispatch(handleFullLayoutLoader(false));
    }, 700);
  } else {
    await addRootStyleTag(themeArr);
  }

  return themeArr;
};
